<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import pageDataMixin from '@qx/mixin/pageData';
import {saveOrUpdateInventoryModel, getAccessoryModelById} from 'api/service';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/service/inventoryManagement/accessoryType/edit',
      formComponents: ['baseForm'],
      subLoading: false,
    };
  },
  computed: {
    detailParams () {
      return {
        id: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: getAccessoryModelById,
    editApi: saveOrUpdateInventoryModel,
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
